// Confirmed plans configured on our Onsurity account (shared by Onsurity, 2026-08-11).
// Onsurity's API has no "list available plans" endpoint — planName/policyType must match
// their configuration exactly, so this list is hardcoded here rather than fetched.
export interface OnsurityPlanOption {
  planName: string;
  policyType: string;
}

export const ONSURITY_HEALTH_PLANS: OnsurityPlanOption[] = [
  { planName: "Ekincare OPD 10k", policyType: "2A+2C" },
  { planName: "Ekincare OPD 5k", policyType: "2A+2C" },
  { planName: "Emerald Fam 17", policyType: "4A+4C" },
  { planName: "Heliodor Fam 17", policyType: "4A+4C" },
  { planName: "Jade Fam 17", policyType: "4A+4C" },
];

export const ONSURITY_LIFE_PLANS: OnsurityPlanOption[] = [
  { planName: "WC 5", policyType: "1A" },
];

export const ONSURITY_MAIN_PLANS: OnsurityPlanOption[] = ONSURITY_HEALTH_PLANS.filter(
  (p) => !p.planName.startsWith("Ekincare OPD")
);

export const ONSURITY_OPD_PLANS: OnsurityPlanOption[] = ONSURITY_HEALTH_PLANS.filter((p) =>
  p.planName.startsWith("Ekincare OPD")
);

// Onsurity enrolls a main plan and an OPD add-on as two separate calls, and a member can hold only
// one main plan — so the dropdown offers each main plan alone, or paired with one OPD tier.
export interface OnsurityPlanCombo {
  key: string;
  label: string;
  main: OnsurityPlanOption;
  opd?: OnsurityPlanOption;
}

const shortName = (p: OnsurityPlanOption) => p.planName.replace(" Fam 17", "").replace("Ekincare ", "");

export const ONSURITY_PLAN_COMBOS: OnsurityPlanCombo[] = ONSURITY_MAIN_PLANS.flatMap((main) => [
  ...ONSURITY_OPD_PLANS.slice()
    .sort((a, b) => a.planName.localeCompare(b.planName, undefined, { numeric: true }))
    .map((opd) => ({
      key: `${main.planName}|${opd.planName}`,
      label: `${shortName(main)} + ${shortName(opd)}`,
      main,
      opd,
    })),
  { key: `${main.planName}|`, label: `${shortName(main)} only`, main },
]);
